<template>
  <div class="margin-bottom-15">
    <div class="d-flex flex-column align-items-end">
      <div class="">
        <el-button type="primary" @click="isShowCreateFolderForm = true" > Tạo thư mục </el-button>
      </div>
    </div>
    <el-dialog :visible.sync="isShowCreateFolderForm" width="70%">
      <div class="title_popup text-center">Tạo thư mục mới</div>

      <el-form ref="formPlagiarism" label-width="250px" label-position="right">
        <el-form-item label="Tên thư mục">
          <el-input placeholder="Tên thư mục" v-model="tag.name"></el-input>
        </el-form-item>
        <el-form-item label="Mô tả">
          <el-input type="textarea" :rows="3" placeholder="Mô tả" v-model="tag.description"> </el-input>
        </el-form-item>
        <el-form-item label="Quyền">
          <el-checkbox-group v-model="tag.permissions">
            <el-checkbox
              v-for="permission in allPermissions"
              :label="permission.value"
              :disabled="permission.required"
              :key="permission.value"
              border
              >{{ permission.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCreateFolderForm = false"><FAIcon icon="fas fa-times" /> Hủy bỏ</el-button>
        <el-button type="primary" @click="onSubmitCreateTagForm" :disabled="loading"
          ><FAIcon icon="fas fa-plus" /> Tạo thư mục</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TagPermissions } from '@/constants/DoITConstant'
import { apiCreateTag } from '@/services/tag_management_service'
import FAIcon from '@/components/common/FAIcon'

export default {
  name: 'TagCreate',
  components: {
    FAIcon,
  },
  data: function () {
    return {
      isShowCreateFolderForm: false,
      mode_page_check: 'all',
      fileList: [],
      loading: false,
      dateRange: [],
      allPermissions: TagPermissions,
      tag: {
        permissions: Object.values(TagPermissions).map((p) => p.value),
        description: '',
        name: '',
        openTime: null,
        expiredTime: null,
      },
    }
  },
  methods: {
    onSubmitCreateTagForm() {
      this.tag.openTime = this.dateRange[0] ? this.dateRange[0].getTime() : null
      this.tag.expiredTime = this.dateRange[1] ? this.dateRange[1].getTime() : null
      this.loading = true
      apiCreateTag(this.tag)
        .then(() => {
          this.$message({
            message: 'Tạo thư mục mới thành công',
            type: 'success',
          })
          this.$emit('success')
          this.isShowCreateFolderForm = false
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.date-picker {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.el-form-item__label {
  font-size: 18px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/*#separator {*/
/*font-size: 20px;*/
/*}*/
/*.el-date-editor.el-input {*/
/*margin-right: 10px;*/
/*margin-left: 10px;*/
/*}*/
</style>
